import React from 'react';
import Paragraph from 'app_previous/elements/typography/paragraph';
import PaperPlane from 'src/app_previous/images/PaperPlane';
import { InputMobileButton } from './GeneratorMobileButton.styles';
import { palette } from 'app_previous/styles/colors';

interface GeneratorMobileButtonProps {
  handleSubmit?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  backgroundColor?: string;
  borderColor?: string;
}

const GeneratorMobileButton = ({
  handleSubmit,
  text,
  backgroundColor = palette.accentBlue,
  borderColor = palette.accentBlue,
}: GeneratorMobileButtonProps): JSX.Element => {
  return (
    <InputMobileButton
      onClick={handleSubmit}
      className='generator-input-mobile-button'
      backgroundColor={backgroundColor}
      borderColor={borderColor}
    >
      <Paragraph
        text={text}
        color={palette.white}
        standardSize='1'
        weight={700}
        align='center'
      />
      <PaperPlane width='20px' />
    </InputMobileButton>
  );
};

export default GeneratorMobileButton;
